// formatDateTime.js (or paste at top of your component file)
export const formatDateTime = (isoString, { hour12 = false } = {}) => {
   console.log("USING NEW FORMATTER");
  if (!isoString) return "Unknown Date";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return isoString; // invalid date -> return raw
  // Date part: 23 Sep 2025
  const date = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  // Time part: 14:35  or 2:35 PM if hour12 true
  const time = d.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12,
  });
  return `${date}`;
};

// If you want only date:
export const formatDateOnly = (isoString) => {
   console.log("USING NEW FORMATTER1");
  if (!isoString) return "Unknown Date";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return isoString;
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};
